// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bcy_a bhr_ea bhr_ke bhr_ju bhr_sn bhr_wl"};